import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const UVM = () => {
  return (
    <div>
          <Helmet>
          <title>UVM Training Institutes - Advanced UVM Training | Takshila VLSI | Verilog Training | SystemVerilog Training | VHDL Training</title>
            <meta name="description" content="Takshila VLSI offers UVM Training to master Universal Verification Methodology. Gain industry-relevant skills and hands-on experience in digital design verification." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/product/uvm-training/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UVM Training Institutes - Advanced UVM Training | Takshila VLSI | Verilog Training | SystemVerilog Training | VHDL Training" />
            <meta property="og:description" content="Takshila VLSI offers UVM Training to master Universal Verification Methodology. Gain industry-relevant skills and hands-on experience in digital design verification." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/product/uvm-training/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-11-28T13:14:13+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/08/UVM-Training.jpg" />
            <meta property="og:image:width" content="4288" />
            <meta property="og:image:height" content="2848" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta name="twitter:card" content="summary_large_image" />
           </Helmet>
          <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>UVM 
                                  <span className='bg-txt mx-3'>Training</span>
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-5">
                                  <h1 className='ws-section_heading pd-03'><span className='font-thin'>UVM Training
                                  </span> Courses in Bangalore/ Hyderabad</h1>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>
                                  <p>The Accellera Universal Verification Methodology (UVM) standard defines a methodology for using SystemVerilog for the verification of complex designs. Get UVM training from one of the most reliable UVM Training Institutes. UVM enables engineers to write thorough and reusable test environment is a robust methodology with many advanced features. In this SystemVerilog UVM training, engineers will learn to apply the UVM for transaction level verification, constrained random test generation, coverage, and scoreboarding. Topics include UVM test phases, UVM class libraries, UVM utilities, UVM factories, UVM sequencers, UVM drivers, UVM Monitors, UVM scoreboards, UVM registers, and configuring UVM tests.</p>
                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 p-2 bg-14'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in VLSI System Design/Embedded Systems/Digital Electronics.
                      </div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Must be familiar with SystemVerilog object-oriented programming.
                      </div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>9 Weeks</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Classes conducted by working professionals from industry.</div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>All Modules include the required hands on work.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Emphasized on UVM concepts and libraries, UVM Test bench structuring and functional coverage.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Assignments with fully automated Verification flow.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Project on Industry accepted protocol-lgs.</div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Lab Support with classroom practice handouts and course material.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, job oriented UVM training with 100% placement assistance.
                      </div>
                  </div>
                  
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/rajiv/'><h4>Mr. Rajiv</h4></a>
              <h6 className='pb-3'>(ASIC Verification Specialist)</h6>
              <p>Mr. Rajiv comes with a 13+ years of rich experience in Design Verification in IP, Sub-System and SoC levels. Working experience in multiple protocol-lgs like PCIe, USB, SATA, DDR, Ethernet etc, and also he has working experience in both ASIC and FPGA design flows. We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.
              </p>
              
              <div class="wpb_wrapper"><p>We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.</p>
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Skills:</strong><br/>
                        Verilog, VHDL,<br/>
                        System Verilog<br/>
                        UVM, OVM, VMM<br/>
                        PERL
                        </p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Protocol-lgs Worked On:</strong><br/>
                        PCIe, USB, SATA, DDR, Ethernet<br/>
                        AMBA Protocol-lgs</p>
                  
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Tools:</strong><br/>
                        ModelSim, VCS, IRUN<br/>
                        Quartus II (Altera FPGA Development Platform)</p>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">Advanced UVM Training
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                  <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              <div className='row'>
                  <div className='col-lg'>
                  <div className='curriculum-accord accordion'>
                          <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>Module 1: UVM Overview</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>The purpose of UVM</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM testbench architecture</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM test phases </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM objects and components </div>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>Module 2: Rapid Review of SystemVerilog Object-Oriented Verification</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>SystemVerilog’s class data type and new() constructors   </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Inheritance, data hiding </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Virtual methods and polymorphism  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Specialized (parameterized) classes </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Object handle assignments and down casting </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Constrained random value generation </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Functional coverage</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>Module 3: UVM First Look</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM class library </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>uvm_object class
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>uvm_component class
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Registering UVM components with the factory
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Virtual interfaces and connecting to the DUT
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM print and debug utilities
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: The big picture — examine all the parts of a complete UVM testbench
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>Module 4: UVM Sequence items and Sequences</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM sequence_items (transactions)
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Defining sequence_item methods
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Using sequence_item field macros
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM sequences of transactions
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Sequence/Driver synchronization
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define and simulate sequence_items and sequences
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>Module 5: UVM Sequencers and Drivers</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM sequencers
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM drivers
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Transaction Level Modeling (TLM)
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>TLM ports, exports, and analysis ports
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define and simulate a UVM driver and sequencer
                                  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>Module 6: UVM Monitors and Agents</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM monitors
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Adding one or more monitor analysis ports
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Agent active and passive modes
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Defining and simulating a UVM monitor and agent
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>Module 7: UVM Functional Coverage</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>A review of System Verilog functional coverage
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Coverage collectors
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Where to add coverage col-lglectors
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Enabling and disabling coverage col-lglectors
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define, simulate, and examine coverage
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>Module 8: UVM Environments, Predictors and Scoreboards
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Scoreboard fundamentals
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Predicting expected results
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Comparing expected and actual results
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Encapsulation in a test environment
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define and simulate a UVM scoreboard and envi- ronment, and verifying the outputs of a (faulty) DUT
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>Module 9: UVM Tests and Advanced Sequences
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Putting everything together in a UVM test
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Running multiple tests
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Virtual sequences and sequencers
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Sequential and parallel sequences
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Sequencer arbitration modes
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Layered sequences
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Driver to sequence feedback
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Top-level modules
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define and simulate a test that runs multiple sequences
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>Module 10: UVM Factory and UVM Configuration
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Understanding the UVM factory
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Registering and constructing verification components
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Factory overrides
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Using the UVM Configuration database
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Reuse and scalability considerations
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>UVM messages and reports
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Lab: Define and simulate a configurable UVM test environment
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="10">
                              <Accordion.Header>Module 11: UVM Register Layer Overview
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>When and where to use verification registers
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Register packages
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Registers and register files
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Bus translators
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Back door access
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Front door access
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Register stimulus generation
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          

                          </Accordion>
                          </div>
                  </div>
              </div>

          </div>
                  </section>

                  <Companysec/>
                  <section className='ws-section pb-5 bg-white'>
                <div class="container text-center">
                <div class="row justify-content-around">
                                <div class="col-lg-6">
                                    <div className='trainer-box'>
                                    
                                        <div className='trainer-img img-radius mb-3'>
                                        <img src={tr1} alt=''/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 text-left">
                                    <h2 className='mb-4'>Why Our UVM and ASIC Verification Training Is the Option That Will Work Best For You</h2>
                                    <p>Whether you happen to be a young engineer looking to enter into the VLSI industry, or are aspiring to build the most amazing career, our UVM and ASIC verification training is surely the training option that will work best for you.</p>
                                    <div className='course-accord dark-bg'>
                                <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>1. The Best in UVM Verification Training</Accordion.Header>
                                    <Accordion.Body>
                                    <p>We are the foremost among the best UVM training institutes if you take a close look at the content and context of the UVM training that we give to our students. UVM (Universal Verification Methodology) is a methodology that defines the utilization of SystemVerilog to verify complex designs. By joining us, you are acquiring the most standard UVM training from one of the best UVM training institutes in the whole world. UVM teaches engineers to write reusable yet very thorough test environments using a robust methodology that offers several advanced features.</p>
                                    <p>After going through our training, engineers become masters at applying UVM to transaction-level verifications, coverage, generation of constrained random tests, as well as scoreboarding. Topics that are taught by the foremost experts of the industry in our training include UVM test phases, UVM utilities, UVM sequencers, UVM monitors, UVM Registers, UVM class libraries, UVM factories, UVM drivers, UVM scoreboards, as well as the configuration of UVM tests.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>2. We Have the Best UVM Training Institutes
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <p>With the foremost UVM training institute in Bangalore which offers the best yet most affordable UVM training for professionals, you should be certain that we offer the best training that the industry has ever seen. We are the best UVM training institute with placement support for our students after the completion of their training. This also makes us the best PERL training institute considering that we have the foremost experts of the entire industry to teach PERL to our students.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>3. Highlights and Features of the Course</Accordion.Header>
                                    <Accordion.Body>
                                    <p>As the complexity of digital systems grows, the methodologies of verification are also becoming progressively more essential. Even though digital designs could be verified by taking a look at waveforms and conducting manual checks in the early beginnings, the present-day complexity does not allow for such verifications anymore. Consequently, designers have been improving ways of automating the process. That is why we ensure that we give our students the best possible training. The highlights of the features of our training include;</p>
                                    <ul>
                                    <li>Classes that are conducted by the foremost experts who are currently working in the industry.</li>
                                    <li>All modules being accomplished together with hands-on tasks.</li>
                                    <li>Assignments that feature completely automated verification flows.</li>
                                    <li>Laboratory support together with classwork practice handouts as well as the best course materials.</li>
                                    <li>The development of soft skills, UVM training which is job-oriented, together with 100% placement support.</li>
                                    <li>Great emphasis on UVM libraries and concepts, UVM test structuring as well as functional coverage.</li>
                                    <li>Project on the most trending industry-accepted protocol-lgs.</li>
                                    </ul>
                                    <p>In conclusion, there are several other reasons for which our UVM and ASIC verification training is the option that will work best for you, especially when you take all the unique features of the course into consideration. But these listed ones are enough to make you join us. That is surely the best thing you can do for your career.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                
                                </Accordion>
                                </div>
                                </div>
                            </div>
                </div>
            </section>
      <Whysec/>           
      <Offersec/>


      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>

      
      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. What exactly is the UVM training course all about?</Accordion.Header>
                              <Accordion.Body>
                              <p>The UVM training course teaches the Universal Verification Method and how to use SystemVerilog to verify complex digital designs. It’s perfect for those looking to gain hands-on experience with transaction-level verification, test generation, and more.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. Who should consider enrolling in the UVM certification program?</Accordion.Header>
                              <Accordion.Body>
                              <p>This UVM certification training is appropriate for you if you have experience with SystemVerilog and an electrical or VLSI background. It is an excellent resource for engineers looking to further their career prospects and improve their proficiency using verification procedures.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. What makes this VLSI UVM training stand out from others?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our VLSI UVM training stands out because it combines expert instruction with practical, hands-on projects. You will learn from industry professionals and work on real-world protocol-lgs, making the training both comprehensive and relevant.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. How does the UVM professional training prepare me for real-world challenges?</Accordion.Header>
                              <Accordion.Body>
                              <p>The UVM professional training emphasizes hands-on experience and practical skills. You will engage in projects that meet industry standards and receive training on complex subjects to help you tackle real-world verification hurdles effectively.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. What will I learn in the UVM certification course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The UVM certification course will cover everything from UVM test phases and class libraries to advanced topics like UVM scoreboards and functional coverage. It is designed to give you a thorough understanding of UVM for effective design verification.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. Is there any placement support with the UVM certification program?</Accordion.Header>
                              <Accordion.Body>
                              <p>Yes! Our team provides 100% support in placement. We help you connect with employers and guide you in improving your new skills in the job market.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>7. Can I get experience during the advanced UVM training?</Accordion.Header>
                              <Accordion.Body>
                              <p>Absolutely! The advanced UVM training includes many practical labs and projects. You will apply what you learn in the real world, which helps to improve your understanding and skills.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>8. How do I get the advantages from the UVM certification program in my career?</Accordion.Header>
                              <Accordion.Body>
                              <p>The program enhances your skills in the area of design verification, making you more attractive to employers. With our complete training and placement support, you will be trained to advance your career in VLSI and verification.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row g-3">
                              <div class="col-lg-7">
                                  <h1>Don't see your questions ? answered here?</h1>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>

      
      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default UVM